<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">

            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Medical Examination</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <ul class="nav gap-1 mb-4">
              <li class="nav-item">
                <button
                  class="btn btn btn-success"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  @click="add()"
                >Tambah Pemeriksaan</button>
              </li>
            </ul>

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="w-15 text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Pemeriksaan
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="w-15 text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Kategori
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Unit
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-nowrap" scope="col">Nilai Referensi</th>
                    <th class="text-nowrap" scope="col">Deskripsi</th>
                    <th class="text-center" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataList" :key="req.id">
                    <th scope="row">{{ idx + 1 }}</th>
                    <td class="text-nowrap">{{ req.examination_name }}</td>
                    <td class="text-center text-nowrap">{{ req.group }}</td>
                    <td class="text-center text-nowrap">{{ req.unit || '-' }}</td>
                    <td>{{ req.reverence_value || '-' }}</td>
                    <td>{{ req.description || '-' }}</td>
                    <td class="text-center">
                      <small
                        :class="req.statusId == 7 ? 'text-bg-success' : 'text-bg-dark'"
                        class="badge fs-1 bg-opacity-75"
                      >{{ req.site_status.status_name }}</small>
                    </td>
                    <td class="text-nowrap text-end">
                      <a
                        class="btn btn-sm btn-outline-primary me-1"
                        @click="edit(req.id)"
                        title="Edit"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        role="button"
                      >
                        <i class="ti ti-edit fs-3"></i>
                      </a>

                      <a
                        href="#"
                        class="btn btn-sm btn-outline-danger"
                        title="Hapus"
                        @click="deleteData(req.id)"
                      >
                        <i class="ti ti-trash fs-3"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <form @submit.prevent="onSubmit">
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="modalNewExaminationlLabel">{{formTitle}} Pertanyaan</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-4">
                <label for class="form-label">Klasifikasi Kategori *</label>
                <select v-model="form.group" class="form-select" autocomplete="off">
                  <option value="">--- Pilih ---</option>
                  <option value="Keadaan Umum">Keadaan Umum</option>
                  <option value="Tanda-tanda Vital">Tanda-tanda Vital</option>
                  <option value="Pemeriksaan Laboratorium">Pemeriksaan Laboratorium</option>
                  <option value="Darah Rutin">Darah Rutin</option>
                  <option value="Triple Eliminasi">Triple Eliminasi</option>
                  <option value="Urin">Urin</option>
                  <option value="Hasil Pemeriksaan">Hasil Pemeriksaan</option>
                  <option value="Extermitas">Extermitas</option>
                  <option value="Penunjang">Penunjang</option>
                  <option value="Khusus">Khusus</option>
                </select>
              </div>

              <div class="mb-4">
                <label for class="form-label">Pemeriksaan *</label>
                <textarea
                  v-model="form.examination_name"
                  class="form-control"
                  placeholder="Pemeriksaan..."
                  rows="3"
                  autocomplete="off"
                  required
                ></textarea>
              </div>

              <div class="mb-4">
                <label for class="form-label">Unit *</label>
                <input
                  v-model="form.unit"
                  type="text"
                  class="form-control"
                  placeholder="Unit..."
                  autocomplete="off"
                  required
                >
              </div>

              <div class="mb-4">
                <label for class="form-label">Nilai Referensi *</label>
                <input
                  v-model="form.reverence_value"
                  type="text"
                  class="form-control"
                  placeholder="Nilai Referensi..."
                  autocomplete="off"
                  required
                >
              </div>

              <div class="mb-4">
                <label for class="form-label">Deskripsi</label>
                <textarea
                  v-model="form.description"
                  class="form-control"
                  placeholder="Deskripsi..."
                  rows="3"
                  autocomplete="off"
                ></textarea>
              </div>

              <div>
                <label for class="form-label">Status</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.statusId"
                      class="form-check-input"
                      type="radio"
                      name="statusId"
                      id="inlineRadio11"
                      value="7"
                      autocomplete="off"
                      checked
                    >
                    <label class="form-check-label" for="inlineRadio11">Publish</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.statusId"
                      class="form-check-input"
                      type="radio"
                      name="statusId"
                      id="inlineRadio21"
                      value="8"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio21">Draft</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-success">Simpan</button>
              <!-- liveToastBtn -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			form: {
				id: '',
				group: '',
				examination_name: '',
				unit: '',
				reverence_value: '',
				description: '',
				statusId: '7'
			},
			cariTitle: '',
			formTitle: 'Tambah',
			url: 'medical_examination/add',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation'
		})
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			// if (from == "date_start" && this.filter.date_end == "") {
			//   return
			// }
			// if (from == "aging") {
			//   if (this.filter.aging) this.filter.bill_status = "Unpaid";
			// } else if (from == "status") {
			//   if (this.filter.bill_status == "Paid") this.filter.aging = "";
			// }
			// var ds = new Date(this.filter.date_start);
			// var de = new Date(this.filter.date_end);
			this.$store
				.dispatch('location/getData', {
					url: `medical_examination`,
					params: {
						examination_name: this.cariTitle,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
						// status: this.status,
						// search: this.search,
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
					// this.loaded = true;
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		onSubmit() {
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						document.querySelector('#exampleModal [data-bs-dismiss="modal"]').click()
						this.form = {
							id: '',
							group: '',
							examination_name: '',
							unit: '',
							reverence_value: '',
							description: '',
							statusId: '7'
						}
					} else {
					}
				})
		},
		deleteData(id) {
			var conf = confirm('Kamu akan menghapus rekaman ini. Apa kamu yakin?')
			if (conf === false) {
				return
			}

			this.$store
				.dispatch('location/createNewRecord', {
					url: 'medical_examination/delete/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			console.log(data)
			this.form.id = id
			this.form.group = data.group
			this.form.examination_name = data.examination_name
			this.form.unit = data.unit
			this.form.reverence_value = data.reverence_value
			this.form.description = data.description
			this.form.statusId = data.statusId
			this.formTitle = 'Edit'
			this.url = 'medical_examination/update/' + id
			this.method = 'put'
		},
		add() {
			this.form = {
				id: '',
				group: '',
				examination_name: '',
				unit: '',
				reverence_value: '',
				description: '',
				statusId: '7'
			}
			this.formTitle = 'Tambah'
			this.url = 'medical_examination/add'
			this.method = 'post'
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
